/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const add_agm_new_sku = /* GraphQL */ `mutation Add_agm_new_sku($input: [AddAgmNewSku]) {
  add_agm_new_sku(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Add_agm_new_skuMutationVariables,
  APITypes.Add_agm_new_skuMutation
>;
export const add_user_access = /* GraphQL */ `mutation Add_user_access($input: UpdateUserAccessInput) {
  add_user_access(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Add_user_accessMutationVariables,
  APITypes.Add_user_accessMutation
>;
export const add_user_access_agm = /* GraphQL */ `mutation Add_user_access_agm($input: UpdateUserAccessInput) {
  add_user_access_agm(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Add_user_access_agmMutationVariables,
  APITypes.Add_user_access_agmMutation
>;
export const add_user_access_coa = /* GraphQL */ `mutation Add_user_access_coa($input: UpdateUserAccessInput) {
  add_user_access_coa(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Add_user_access_coaMutationVariables,
  APITypes.Add_user_access_coaMutation
>;
export const add_user_access_snro = /* GraphQL */ `mutation Add_user_access_snro($input: UpdateUserAccessInput) {
  add_user_access_snro(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Add_user_access_snroMutationVariables,
  APITypes.Add_user_access_snroMutation
>;
export const add_user_access_verity_dg = /* GraphQL */ `mutation Add_user_access_verity_dg($input: UpdateUserAccessInput) {
  add_user_access_verity_dg(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Add_user_access_verity_dgMutationVariables,
  APITypes.Add_user_access_verity_dgMutation
>;
export const bulkUpdatePrograms = /* GraphQL */ `mutation BulkUpdatePrograms($input: BulkUpdateProgramsInput!) {
  bulkUpdatePrograms(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.BulkUpdateProgramsMutationVariables,
  APITypes.BulkUpdateProgramsMutation
>;
export const createAGMSku = /* GraphQL */ `mutation CreateAGMSku($input: CreateAGMSkuInput!) {
  createAGMSku(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.CreateAGMSkuMutationVariables,
  APITypes.CreateAGMSkuMutation
>;
export const createAttributeApprovalTicket = /* GraphQL */ `mutation CreateAttributeApprovalTicket(
  $input: CreateAttributeApprovalTicketInput!
) {
  createAttributeApprovalTicket(input: $input) {
    ticket_id
  }
}
` as GeneratedMutation<
  APITypes.CreateAttributeApprovalTicketMutationVariables,
  APITypes.CreateAttributeApprovalTicketMutation
>;
export const createAuditLogEntry = /* GraphQL */ `mutation CreateAuditLogEntry($input: CreateAuditLogEntryInput!) {
  createAuditLogEntry(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateAuditLogEntryMutationVariables,
  APITypes.CreateAuditLogEntryMutation
>;
export const createChangeHistory = /* GraphQL */ `mutation CreateChangeHistory($input: CreateChangeHistoryInput!) {
  createChangeHistory(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateChangeHistoryMutationVariables,
  APITypes.CreateChangeHistoryMutation
>;
export const createOrUpdateAGMAssortments = /* GraphQL */ `mutation CreateOrUpdateAGMAssortments(
  $input: CreateOrUpdateAGMAssortmentsInput!
) {
  createOrUpdateAGMAssortments(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateAGMAssortmentsMutationVariables,
  APITypes.CreateOrUpdateAGMAssortmentsMutation
>;
export const createOrUpdateAGMVersions = /* GraphQL */ `mutation CreateOrUpdateAGMVersions($input: CreateOrUpdateAGMVersionsInput!) {
  createOrUpdateAGMVersions(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateAGMVersionsMutationVariables,
  APITypes.CreateOrUpdateAGMVersionsMutation
>;
export const createOrUpdateAnnouncementsDetails = /* GraphQL */ `mutation CreateOrUpdateAnnouncementsDetails(
  $input: [AnnouncementsDetailsInput]
) {
  createOrUpdateAnnouncementsDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateAnnouncementsDetailsMutationVariables,
  APITypes.CreateOrUpdateAnnouncementsDetailsMutation
>;
export const createOrUpdateAttributeDetails = /* GraphQL */ `mutation CreateOrUpdateAttributeDetails($input: AttributeDetailsInput) {
  createOrUpdateAttributeDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateAttributeDetailsMutationVariables,
  APITypes.CreateOrUpdateAttributeDetailsMutation
>;
export const createOrUpdateFPN = /* GraphQL */ `mutation CreateOrUpdateFPN($input: CreateOrUpdateFPNInput!) {
  createOrUpdateFPN(input: $input) {
    created_fpn_ids
    deleted_fpn_ids
    number_of_records_updated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateFPNMutationVariables,
  APITypes.CreateOrUpdateFPNMutation
>;
export const createOrUpdateFPNAdditionalInfo = /* GraphQL */ `mutation CreateOrUpdateFPNAdditionalInfo(
  $input: CreateOrUpdateFPNAdditionalInfoInput!
) {
  createOrUpdateFPNAdditionalInfo(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateFPNAdditionalInfoMutationVariables,
  APITypes.CreateOrUpdateFPNAdditionalInfoMutation
>;
export const createOrUpdateFPNAttributes = /* GraphQL */ `mutation CreateOrUpdateFPNAttributes(
  $input: CreateOrUpdateFPNAttributesInput!
) {
  createOrUpdateFPNAttributes(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateFPNAttributesMutationVariables,
  APITypes.CreateOrUpdateFPNAttributesMutation
>;
export const createOrUpdateFPNCountryKeyDates = /* GraphQL */ `mutation CreateOrUpdateFPNCountryKeyDates(
  $input: CreateOrUpdateFPNCountryKeyDatesInput!
) {
  createOrUpdateFPNCountryKeyDates(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateFPNCountryKeyDatesMutationVariables,
  APITypes.CreateOrUpdateFPNCountryKeyDatesMutation
>;
export const createOrUpdateFPNOverview = /* GraphQL */ `mutation CreateOrUpdateFPNOverview($input: CreateOrUpdateFPNOverviewInput!) {
  createOrUpdateFPNOverview(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateFPNOverviewMutationVariables,
  APITypes.CreateOrUpdateFPNOverviewMutation
>;
export const createOrUpdateProductLineContacts = /* GraphQL */ `mutation CreateOrUpdateProductLineContacts($input: ProductLineContactInput!) {
  createOrUpdateProductLineContacts(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateProductLineContactsMutationVariables,
  APITypes.CreateOrUpdateProductLineContactsMutation
>;
export const createOrUpdateProductLineGroups = /* GraphQL */ `mutation CreateOrUpdateProductLineGroups($input: [ProductLineGroupInput!]!) {
  createOrUpdateProductLineGroups(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateProductLineGroupsMutationVariables,
  APITypes.CreateOrUpdateProductLineGroupsMutation
>;
export const createOrUpdateRPNAdditionalInfo = /* GraphQL */ `mutation CreateOrUpdateRPNAdditionalInfo(
  $input: CreateOrUpdateRPNAdditionalInfoInput!
) {
  createOrUpdateRPNAdditionalInfo(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateRPNAdditionalInfoMutationVariables,
  APITypes.CreateOrUpdateRPNAdditionalInfoMutation
>;
export const createOrUpdateRPNAttributes = /* GraphQL */ `mutation CreateOrUpdateRPNAttributes(
  $input: CreateOrUpdateRPNAttributesInput!
) {
  createOrUpdateRPNAttributes(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateRPNAttributesMutationVariables,
  APITypes.CreateOrUpdateRPNAttributesMutation
>;
export const createOrUpdateRPNCountryKeyDates = /* GraphQL */ `mutation CreateOrUpdateRPNCountryKeyDates(
  $input: CreateOrUpdateRPNCountryKeyDatesInput!
) {
  createOrUpdateRPNCountryKeyDates(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateRPNCountryKeyDatesMutationVariables,
  APITypes.CreateOrUpdateRPNCountryKeyDatesMutation
>;
export const createOrUpdateRPNOverview = /* GraphQL */ `mutation CreateOrUpdateRPNOverview($input: CreateOrUpdateRPNOverviewInput!) {
  createOrUpdateRPNOverview(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateRPNOverviewMutationVariables,
  APITypes.CreateOrUpdateRPNOverviewMutation
>;
export const createOrUpdateReportConfig = /* GraphQL */ `mutation CreateOrUpdateReportConfig($input: ReportConfigInput!) {
  createOrUpdateReportConfig(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateReportConfigMutationVariables,
  APITypes.CreateOrUpdateReportConfigMutation
>;
export const createOrUpdateResourcesDetails = /* GraphQL */ `mutation CreateOrUpdateResourcesDetails($input: [ResourcesDetailsInput]) {
  createOrUpdateResourcesDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateResourcesDetailsMutationVariables,
  APITypes.CreateOrUpdateResourcesDetailsMutation
>;
export const createOrUpdateUserAccess = /* GraphQL */ `mutation CreateOrUpdateUserAccess($input: VerityUserAccessInput) {
  createOrUpdateUserAccess(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateUserAccessMutationVariables,
  APITypes.CreateOrUpdateUserAccessMutation
>;
export const createOrUpdateUserFavorites = /* GraphQL */ `mutation CreateOrUpdateUserFavorites(
  $input: CreateOrUpdateUserFavoritesInput!
) {
  createOrUpdateUserFavorites(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateUserFavoritesMutationVariables,
  APITypes.CreateOrUpdateUserFavoritesMutation
>;
export const createOrUpdateUserPreferencesDetails = /* GraphQL */ `mutation CreateOrUpdateUserPreferencesDetails(
  $input: UserPreferencesDetailsInput
) {
  createOrUpdateUserPreferencesDetails(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateOrUpdateUserPreferencesDetailsMutationVariables,
  APITypes.CreateOrUpdateUserPreferencesDetailsMutation
>;
export const createRPN = /* GraphQL */ `mutation CreateRPN($input: CreateRPNInput!) {
  createRPN(input: $input) {
    is_pplsid_available
    number_of_records_updated
    rpn_id
  }
}
` as GeneratedMutation<
  APITypes.CreateRPNMutationVariables,
  APITypes.CreateRPNMutation
>;
export const createSnapshot = /* GraphQL */ `mutation CreateSnapshot($input: SnapshotScenarioDetailsInput!) {
  createSnapshot(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.CreateSnapshotMutationVariables,
  APITypes.CreateSnapshotMutation
>;
export const create_attr_pl_type = /* GraphQL */ `mutation Create_attr_pl_type($input: [AttributePLTypeInput]) {
  create_attr_pl_type(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Create_attr_pl_typeMutationVariables,
  APITypes.Create_attr_pl_typeMutation
>;
export const create_rpn = /* GraphQL */ `mutation Create_rpn($input: [RPNInput]) {
  create_rpn(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Create_rpnMutationVariables,
  APITypes.Create_rpnMutation
>;
export const deactivateAGMSku = /* GraphQL */ `mutation DeactivateAGMSku($input: DeactivateAGMSkuInput!) {
  deactivateAGMSku(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.DeactivateAGMSkuMutationVariables,
  APITypes.DeactivateAGMSkuMutation
>;
export const deactivate_agm_sku = /* GraphQL */ `mutation Deactivate_agm_sku($input: DeactivateAgmSku) {
  deactivate_agm_sku(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Deactivate_agm_skuMutationVariables,
  APITypes.Deactivate_agm_skuMutation
>;
export const del_bdgt_typ = /* GraphQL */ `mutation Del_bdgt_typ($input: [coa_delete_budget_types]) {
  del_bdgt_typ(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Del_bdgt_typMutationVariables,
  APITypes.Del_bdgt_typMutation
>;
export const deleteAGMAssortments = /* GraphQL */ `mutation DeleteAGMAssortments($input: DeleteAGMAssortmentsInput!) {
  deleteAGMAssortments(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.DeleteAGMAssortmentsMutationVariables,
  APITypes.DeleteAGMAssortmentsMutation
>;
export const delete_agm_version = /* GraphQL */ `mutation Delete_agm_version($version_id: Int) {
  delete_agm_version(version_id: $version_id) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Delete_agm_versionMutationVariables,
  APITypes.Delete_agm_versionMutation
>;
export const delete_cc_el = /* GraphQL */ `mutation Delete_cc_el($input: [coa_delete_cost_ctr_expli]) {
  delete_cc_el(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Delete_cc_elMutationVariables,
  APITypes.Delete_cc_elMutation
>;
export const frames_mngr = /* GraphQL */ `mutation Frames_mngr($input: [frames_s3]) {
  frames_mngr(input: $input) {
    body
    error
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Frames_mngrMutationVariables,
  APITypes.Frames_mngrMutation
>;
export const frames_s3 = /* GraphQL */ `mutation Frames_s3($input: [frames_s3]) {
  frames_s3(input: $input) {
    body
    error
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Frames_s3MutationVariables,
  APITypes.Frames_s3Mutation
>;
export const get_frames_api_data = /* GraphQL */ `mutation Get_frames_api_data($input: [get_frames_api_data]) {
  get_frames_api_data(input: $input) {
    body
    error
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Get_frames_api_dataMutationVariables,
  APITypes.Get_frames_api_dataMutation
>;
export const manageGridView = /* GraphQL */ `mutation ManageGridView($input: ManageGridViewInput!) {
  manageGridView(input: $input) {
    action
    data
    message
    number_of_records_updated
    success
  }
}
` as GeneratedMutation<
  APITypes.ManageGridViewMutationVariables,
  APITypes.ManageGridViewMutation
>;
export const parse_prm_wip = /* GraphQL */ `mutation Parse_prm_wip($input: RefreshSnapshotInput) {
  parse_prm_wip(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Parse_prm_wipMutationVariables,
  APITypes.Parse_prm_wipMutation
>;
export const post_attr_list_fpn = /* GraphQL */ `mutation Post_attr_list_fpn($input: [AttributeListFPNInput]) {
  post_attr_list_fpn(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Post_attr_list_fpnMutationVariables,
  APITypes.Post_attr_list_fpnMutation
>;
export const post_attr_list_master = /* GraphQL */ `mutation Post_attr_list_master($input: PostAttrListMaster) {
  post_attr_list_master(input: $input) {
    body
    error
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Post_attr_list_masterMutationVariables,
  APITypes.Post_attr_list_masterMutation
>;
export const post_attr_list_rpn = /* GraphQL */ `mutation Post_attr_list_rpn($input: [AttributeListRPNInput]) {
  post_attr_list_rpn(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Post_attr_list_rpnMutationVariables,
  APITypes.Post_attr_list_rpnMutation
>;
export const post_attr_type_master = /* GraphQL */ `mutation Post_attr_type_master($input: PostAttrTypeMaster) {
  post_attr_type_master(input: $input) {
    body
    error
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Post_attr_type_masterMutationVariables,
  APITypes.Post_attr_type_masterMutation
>;
export const post_attr_type_rpn = /* GraphQL */ `mutation Post_attr_type_rpn($input: [AttributeTypeRPNInput]) {
  post_attr_type_rpn(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Post_attr_type_rpnMutationVariables,
  APITypes.Post_attr_type_rpnMutation
>;
export const post_fpn = /* GraphQL */ `mutation Post_fpn($input: [FPNInput]) {
  post_fpn(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Post_fpnMutationVariables,
  APITypes.Post_fpnMutation
>;
export const post_rpn_fpn_rule = /* GraphQL */ `mutation Post_rpn_fpn_rule($input: [RPNFPNRuleInput]) {
  post_rpn_fpn_rule(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Post_rpn_fpn_ruleMutationVariables,
  APITypes.Post_rpn_fpn_ruleMutation
>;
export const ppls_create_program = /* GraphQL */ `mutation Ppls_create_program($input: PPLSCreateProgramInput) {
  ppls_create_program(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Ppls_create_programMutationVariables,
  APITypes.Ppls_create_programMutation
>;
export const reactivateAGMSku = /* GraphQL */ `mutation ReactivateAGMSku($input: ReactivateAGMSkuInput!) {
  reactivateAGMSku(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.ReactivateAGMSkuMutationVariables,
  APITypes.ReactivateAGMSkuMutation
>;
export const reactivate_agm_sku = /* GraphQL */ `mutation Reactivate_agm_sku($input: DeactivateAgmSku) {
  reactivate_agm_sku(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Reactivate_agm_skuMutationVariables,
  APITypes.Reactivate_agm_skuMutation
>;
export const refreshChangeHistoryExport = /* GraphQL */ `mutation RefreshChangeHistoryExport($input: RefreshChangeHistoryExportInput!) {
  refreshChangeHistoryExport(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshChangeHistoryExportMutationVariables,
  APITypes.RefreshChangeHistoryExportMutation
>;
export const refreshSnapshot = /* GraphQL */ `mutation RefreshSnapshot($input: SnapshotScenarioDetailsInput!) {
  refreshSnapshot(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.RefreshSnapshotMutationVariables,
  APITypes.RefreshSnapshotMutation
>;
export const refresh_prm_snapshot = /* GraphQL */ `mutation Refresh_prm_snapshot($input: RefreshSnapshotInput) {
  refresh_prm_snapshot(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Refresh_prm_snapshotMutationVariables,
  APITypes.Refresh_prm_snapshotMutation
>;
export const remapAGMAsin = /* GraphQL */ `mutation RemapAGMAsin($input: RemapAGMAsinInput!) {
  remapAGMAsin(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.RemapAGMAsinMutationVariables,
  APITypes.RemapAGMAsinMutation
>;
export const remap_asin = /* GraphQL */ `mutation Remap_asin($input: RemapAsinInput) {
  remap_asin(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Remap_asinMutationVariables,
  APITypes.Remap_asinMutation
>;
export const remove_agm_assort = /* GraphQL */ `mutation Remove_agm_assort($assortment_id: Int) {
  remove_agm_assort(assortment_id: $assortment_id) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Remove_agm_assortMutationVariables,
  APITypes.Remove_agm_assortMutation
>;
export const request_pn = /* GraphQL */ `mutation Request_pn($input: RequestPartNumberInput) {
  request_pn(input: $input) {
    body {
      part_number
      sku_id
    }
    error
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Request_pnMutationVariables,
  APITypes.Request_pnMutation
>;
export const saveGanttChartSettings = /* GraphQL */ `mutation SaveGanttChartSettings($input: [SaveGanttChartSettingsInput]!) {
  saveGanttChartSettings(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.SaveGanttChartSettingsMutationVariables,
  APITypes.SaveGanttChartSettingsMutation
>;
export const take_prm_snapshot = /* GraphQL */ `mutation Take_prm_snapshot($input: SnapshotInput) {
  take_prm_snapshot(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Take_prm_snapshotMutationVariables,
  APITypes.Take_prm_snapshotMutation
>;
export const unlockAGMSkuOverride = /* GraphQL */ `mutation UnlockAGMSkuOverride($input: UnlockAGMSkuOverrideInput!) {
  unlockAGMSkuOverride(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.UnlockAGMSkuOverrideMutationVariables,
  APITypes.UnlockAGMSkuOverrideMutation
>;
export const unlockSkuOverride = /* GraphQL */ `mutation UnlockSkuOverride($input: UnlockSkuOverrideInput) {
  unlockSkuOverride(input: $input) {
    body
    error
    override_email_sent
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.UnlockSkuOverrideMutationVariables,
  APITypes.UnlockSkuOverrideMutation
>;
export const updateAGMAttributeOrder = /* GraphQL */ `mutation UpdateAGMAttributeOrder($input: UpdateAGMAttributeOrderInput!) {
  updateAGMAttributeOrder(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.UpdateAGMAttributeOrderMutationVariables,
  APITypes.UpdateAGMAttributeOrderMutation
>;
export const updateAGMSkuAssortments = /* GraphQL */ `mutation UpdateAGMSkuAssortments($input: UpdateAGMSkuAssortmentsInput!) {
  updateAGMSkuAssortments(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.UpdateAGMSkuAssortmentsMutationVariables,
  APITypes.UpdateAGMSkuAssortmentsMutation
>;
export const updateAGMSkuMarketplaces = /* GraphQL */ `mutation UpdateAGMSkuMarketplaces($input: UpdateAGMSkuMarketplacesInput!) {
  updateAGMSkuMarketplaces(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.UpdateAGMSkuMarketplacesMutationVariables,
  APITypes.UpdateAGMSkuMarketplacesMutation
>;
export const updateAGMSkuVersionType = /* GraphQL */ `mutation UpdateAGMSkuVersionType($input: UpdateAGMSkuVersionTypeInput!) {
  updateAGMSkuVersionType(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.UpdateAGMSkuVersionTypeMutationVariables,
  APITypes.UpdateAGMSkuVersionTypeMutation
>;
export const updateProductLine = /* GraphQL */ `mutation UpdateProductLine($input: UpdateProductLineInput!) {
  updateProductLine(input: $input) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<
  APITypes.UpdateProductLineMutationVariables,
  APITypes.UpdateProductLineMutation
>;
export const updateRPN = /* GraphQL */ `mutation UpdateRPN($input: UpdateRPNInput!) {
  updateRPN(input: $input) {
    is_pplsid_available
    number_of_records_updated
    rpn_id
  }
}
` as GeneratedMutation<
  APITypes.UpdateRPNMutationVariables,
  APITypes.UpdateRPNMutation
>;
export const update_acc_proj = /* GraphQL */ `mutation Update_acc_proj($input: [coa_update_accessory_projects]) {
  update_acc_proj(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_acc_projMutationVariables,
  APITypes.Update_acc_projMutation
>;
export const update_accounts = /* GraphQL */ `mutation Update_accounts($input: [coa_update_accounts]) {
  update_accounts(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_accountsMutationVariables,
  APITypes.Update_accountsMutation
>;
export const update_agm_assort = /* GraphQL */ `mutation Update_agm_assort($input: UpdateAgmAssortments) {
  update_agm_assort(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_agm_assortMutationVariables,
  APITypes.Update_agm_assortMutation
>;
export const update_agm_att_sort = /* GraphQL */ `mutation Update_agm_att_sort($input: UpdateAgmProgAttSort) {
  update_agm_att_sort(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_agm_att_sortMutationVariables,
  APITypes.Update_agm_att_sortMutation
>;
export const update_agm_sku_assortments = /* GraphQL */ `mutation Update_agm_sku_assortments($input: UpdateAgmSkuAssort) {
  update_agm_sku_assortments(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_agm_sku_assortmentsMutationVariables,
  APITypes.Update_agm_sku_assortmentsMutation
>;
export const update_agm_sku_mp = /* GraphQL */ `mutation Update_agm_sku_mp($input: UpdateAgmSkuMp) {
  update_agm_sku_mp(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_agm_sku_mpMutationVariables,
  APITypes.Update_agm_sku_mpMutation
>;
export const update_agm_sku_version_and_type = /* GraphQL */ `mutation Update_agm_sku_version_and_type($input: UpdateAgmSkuVersionType) {
  update_agm_sku_version_and_type(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_agm_sku_version_and_typeMutationVariables,
  APITypes.Update_agm_sku_version_and_typeMutation
>;
export const update_agm_versions = /* GraphQL */ `mutation Update_agm_versions($input: UpdateAgmVersionsInput) {
  update_agm_versions(input: $input) {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_agm_versionsMutationVariables,
  APITypes.Update_agm_versionsMutation
>;
export const update_bdgt_typ = /* GraphQL */ `mutation Update_bdgt_typ($input: [coa_update_budget_types]) {
  update_bdgt_typ(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_bdgt_typMutationVariables,
  APITypes.Update_bdgt_typMutation
>;
export const update_budget_bl = /* GraphQL */ `mutation Update_budget_bl($input: [coa_update_budget_bl]) {
  update_budget_bl(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_budget_blMutationVariables,
  APITypes.Update_budget_blMutation
>;
export const update_cc = /* GraphQL */ `mutation Update_cc($input: [coa_update_cost_centers]) {
  update_cc(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_ccMutationVariables,
  APITypes.Update_ccMutation
>;
export const update_cc_el = /* GraphQL */ `mutation Update_cc_el($input: [coa_update_cost_ctr_expli]) {
  update_cc_el(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_cc_elMutationVariables,
  APITypes.Update_cc_elMutation
>;
export const update_cc_gr = /* GraphQL */ `mutation Update_cc_gr($input: [coa_update_cost_center_groups]) {
  update_cc_gr(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_cc_grMutationVariables,
  APITypes.Update_cc_grMutation
>;
export const update_comdty = /* GraphQL */ `mutation Update_comdty($input: [coa_update_commoditys]) {
  update_comdty(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_comdtyMutationVariables,
  APITypes.Update_comdtyMutation
>;
export const update_exp_typ = /* GraphQL */ `mutation Update_exp_typ($input: [coa_update_expense_types]) {
  update_exp_typ(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_exp_typMutationVariables,
  APITypes.Update_exp_typMutation
>;
export const update_exp_up_re = /* GraphQL */ `mutation Update_exp_up_re($input: [coa_update_exp_update_re]) {
  update_exp_up_re(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_exp_up_reMutationVariables,
  APITypes.Update_exp_up_reMutation
>;
export const update_product_gr = /* GraphQL */ `mutation Update_product_gr($input: [coa_update_product_groups]) {
  update_product_gr(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_product_grMutationVariables,
  APITypes.Update_product_grMutation
>;
export const update_products = /* GraphQL */ `mutation Update_products($input: [coa_update_products]) {
  update_products(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_productsMutationVariables,
  APITypes.Update_productsMutation
>;
export const update_prog_fpn_time = /* GraphQL */ `mutation Update_prog_fpn_time {
  update_prog_fpn_time {
    body
    error
    lastSucceededIndex
    statusCode
  }
}
` as GeneratedMutation<
  APITypes.Update_prog_fpn_timeMutationVariables,
  APITypes.Update_prog_fpn_timeMutation
>;
export const update_projects = /* GraphQL */ `mutation Update_projects($input: [coa_update_projects]) {
  update_projects(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_projectsMutationVariables,
  APITypes.Update_projectsMutation
>;
export const update_rpn = /* GraphQL */ `mutation Update_rpn($input: [RPNUpdateInput]) {
  update_rpn(input: $input) {
    body
    error
    erroredCode
    statusCode
    updatedCodes
  }
}
` as GeneratedMutation<
  APITypes.Update_rpnMutationVariables,
  APITypes.Update_rpnMutation
>;
